import React from 'react'
import EducationAndExperienceSection from './EducationAndExperienceSection'
import SalarySection from './SalarySection'
import TraitsSection from './TraitsSection'
import TechnologySkillsSection from './TechnologySkillsSection'
import useCareerExploration from './CareerExplorationProvider'
import CareerDescriptionSection from './CareerDescriptionSection'
import useTranslation from '../shared/TranslationProvider'
import { cn } from '~/lib/utils'
import RelatedOccupationsSection from './RelatedOccupationsSection'
import JobTasksSection from './JobTasksSection'
import ResponsibilitiesSection from './ResponsibilitiesSection'
import VideoSection from './VideoSection'

const Results = () => {
  const {
    careers,
    compare,
    careerDescriptionRef,
    jobTasksRef,
    responsibilitiesRef,
    educationAndExperienceRef,
    salaryRef,
    relatedOccupationsRef,
    traitsRef,
    technologySkillsRef,
    showEducationAndExperience,
    careerDescription,
    keyResponsibilities,
    hasTraits,
    videoRef,
    showSalaryData,
  } = useCareerExploration()

  const showCareerDescription =
    !!careerDescription(careers[0])?.length ||
    !!careerDescription(careers[1])?.length

  const showKeyResponsibilities =
    !!keyResponsibilities(careers[0])?.length ||
    !!keyResponsibilities(careers[1])?.length

  const showRelatedOccupations =
    !!careers[1]?.related?.length || !!careers[0].related?.length

  const showTasks = !!careers[0].tasks?.length || !!careers[1]?.tasks?.length

  const showTechnologySkills =
    !!Object.keys(careers[0].technology_skills)?.length ||
    !!Object.keys(careers[1]?.technology_skills)?.length

  const showTraitsSection = hasTraits(careers[0]) || hasTraits(careers[1])

  const showVideoSection = careers[0].video || careers[1]?.video

  const sectionClassName = compare ? 'col-span-1' : 'col-span-2'
  // const divideClass = compare ? 'divide-x-2 divide-[#B9B9B9]' : ''
  return (
    <div className={cn('grid grid-cols-1 gap-12 md:grid-cols-2')}>
      {careers.map((career, idx) => (
        <Title
          key={`career-${idx}`}
          career={career}
          className={sectionClassName}
        />
      ))}
      {showCareerDescription &&
        careers.map((career, idx) => (
          <CareerDescriptionSection
            key={`career-description-${idx}`}
            career={career}
            className={sectionClassName}
            eleRef={careerDescriptionRef}
          />
        ))}
      {showVideoSection &&
        careers.map((career, idx) => (
          <VideoSection
            key={`career-video-${idx}`}
            career={career}
            className={sectionClassName}
            eleRef={videoRef}
          />
        ))}
      {showEducationAndExperience &&
        careers.map((career, idx) => (
          <EducationAndExperienceSection
            key={`career-experience-levels-${idx}`}
            career={career}
            className={sectionClassName}
            eleRef={educationAndExperienceRef}
          />
        ))}
      {showKeyResponsibilities &&
        careers.map((career, idx) => (
          <ResponsibilitiesSection
            key={`career-responsibilities-${idx}`}
            career={career}
            className={sectionClassName}
            eleRef={responsibilitiesRef}
          />
        ))}
      {showSalaryData() && <SalarySection eleRef={salaryRef} />}
      {showRelatedOccupations &&
        careers.map((career, idx) => (
          <RelatedOccupationsSection
            key={`career-related-occupations-${idx}`}
            career={career}
            className={sectionClassName}
            eleRef={relatedOccupationsRef}
            showSalaryData={showSalaryData()}
          />
        ))}
      {showTasks &&
        careers.map((career, idx) => (
          <JobTasksSection
            key={`career-job-tasks-${idx}`}
            career={career}
            className={sectionClassName}
            eleRef={jobTasksRef}
          />
        ))}
      {showTraitsSection &&
        careers.map((career, idx) => (
          <TraitsSection
            key={`career-traits-${idx}`}
            career={career}
            className={sectionClassName}
            eleRef={traitsRef}
          />
        ))}
      {showTechnologySkills &&
        careers.map((career, idx) => (
          <TechnologySkillsSection
            key={`career-technology-${idx}`}
            section="skills"
            career={career}
            className={sectionClassName}
            eleRef={technologySkillsRef}
          />
        ))}
    </div>
  )
}

export default Results

const Title = ({ career }) => {
  const { compare } = useCareerExploration()
  const query = window.location.search
  const href = `/career_exploration${query}`
  const { t } = useTranslation('Page')
  if (compare) return <h2 className="mt-8">{career.occupation.title}</h2>
  return (
    <div>
      <h2 className="mt-8">{career.occupation.title}</h2>
      <a href={href}>{t('compare_career')}</a>
    </div>
  )
}

export const PageHeading = () => {
  const { t } = useTranslation('Page')
  return (
    <h1 className="mb-4 !font-roboto-slab text-2xl text-[32px] font-medium text-cloud-burst">
      <span className="font-normal">{t('light_heading')}</span>{' '}
      {t('dark_heading')}
    </h1>
  )
}
